import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

export type GetRosaScoresRequest = BaseContext & {
	report_id: string;
};

export type GetRosaScoresResponse = {
	score_a: number;
	score_b: number;
	score_c: number;
	final_score: number;
};

async function getScores(params: GetRosaScoresRequest): Promise<GetRosaScoresResponse> {
	const url = `ergonomic-tool/rosa/scores/${params.report_id}`;
	const { data } = await Api.get<GetRosaScoresResponse>(url, { params });
	return data;
}

export const useGetRosaScores = (params: GetRosaScoresRequest) => {
	return useQuery([ROSA_QUERY_KEYS.GET_SCORES], () => getScores(params));
};
